module.exports = __webpack_public_path__ + "static/media/give-share-badge.84cbc4fa.png";